import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { Collapse, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';

import { clientSettingsSelector, toggleSidebar } from '../../../store/slices/clientsettings';

const SidebarMenu = ({ items, level = 0, isOpen, activeRoute, preview, availableOptions }) => {
  const [openSubMenu, setOpenSubMenu] = useState({});
  const { isToggleSidebarOpen: sidebarOpen } = useSelector(clientSettingsSelector);
  const isToggleSidebarOpen = Boolean(preview) || sidebarOpen;
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onNavItemClick = (e, item, index) => {
    e.preventDefault();
    // **Check if the item has children**
    if (item.children && item.children.length > 0) {
      if (!isToggleSidebarOpen) {
        dispatch(toggleSidebar());

        // **Wait for the sidebar to expand, then toggle the submenu**
        setTimeout(() => {
          setOpenSubMenu((prev) => ({ ...prev, [index]: true }));
        }, 300); // Delay ensures state doesn't reset immediately
      } else {
        setOpenSubMenu((prev) => ({ ...prev, [index]: !prev[index] }));
      }

      return;
    }
    // **If no children, reset submenu state**
    setOpenSubMenu({});

    // If in preview mode, prevent navigation
    if (preview) {
      e.preventDefault();
      return;
    }

    // **Trigger onClick event or navigate**
    if (item.onClick) {
      return item.onClick(e);
    }
    navigate(item.path);
  };

  useEffect(() => {
    // Expand submenu if any child is active
    const updatedOpenState = {};
    items.forEach((item, index) => {
      if (item.children?.some((child) => child.path === activeRoute)) {
        updatedOpenState[index] = true;
      }
    });
    setOpenSubMenu(updatedOpenState);
  }, [activeRoute, items]);

  return (
    <List className="sidebar-list" style={{ paddingLeft: level * 15 }} sx={{ flex: 1, minHeight: 0, overflowY: 'overlay' }}>
      {items.map((item, index) => {
        // **Check if any child is active**
        const isChildActive = item.children?.some((child) => child.path === activeRoute);

        return (
          <div key={index}>
            <ListItem
              disablePadding
              className={`list-item ${activeRoute === item.path && !preview ? 'active' : ''} ${
                isChildActive ? 'has-active-child' : ''
              }`}
              title={item.text}
            >
              <ListItemButton
                className="item-btn"
                component={Link}
                to={preview ? '#' : item.path}
                onClick={(e) => onNavItemClick(e, item, index)}
              >
                <ListItemIcon className="menu-icon">{item.icon}</ListItemIcon>
                {isOpen && <ListItemText className="item-text" primary={item.text} />}
                {item.children && item.children.length > 0 && isOpen && (
                  <ListItemIcon className="menu-icon">{openSubMenu[index] ? <ExpandLess /> : <ExpandMore />}</ListItemIcon>
                )}
              </ListItemButton>
            </ListItem>

            {item.children && item.children.length > 0 && isOpen && (
              <Collapse in={openSubMenu[index]} timeout="auto" unmountOnExit>
                <SidebarMenu
                  items={item.children}
                  isOpen={isOpen}
                  level={level + 1}
                  activeRoute={activeRoute}
                  preview={preview}
                  availableOptions={availableOptions}
                />
              </Collapse>
            )}
          </div>
        );
      })}
    </List>
  );
};

export default SidebarMenu;
